const list = {
  // =================================================================================================================
  components() {
    return [
      // {
      //   'component': 'search-start-end',
      //   label: '작성일',
      //   value: 'date',
      //   query: {'ss': 'startDate', 'ee': 'endDate'},
      //   options: {
      //     default: {sd: '', ed: ''},
      //   }
      // },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['구분', '작성일', '작성년도']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // // 검색연도
    // let dateTarget = "created_at";
    // let dateBegin = `${new Date().getFullYear()}-01-01`;
    // let dateEnd = `${new Date().getFullYear()}-12-31`;
    // if (search.year) {
    //   dateBegin = `${search.year}-01-01`;
    //   dateEnd = `${search.year}-12-31`;
    // }
    // //  검색일
    // if (search.date) {
    //   if (search.date.startDate) dateBegin = search.date.startDate;
    //   if (search.date.endDate) dateEnd = search.date.endDate;
    // }
    // conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    // conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "부서명",
        "key": "body.부서명"
      },
      {
        "name": "담당 주무관",
        "key": "body.담당주무관"
      },
      {
        "name": "부서 주소",
        "key": "body.부서주소"
      },
      {
        "name": "부서 연락처",
        "key": "body.부서연락처"
      },
    ]
  },
  getCol: (index, value, func) => {
    switch (index) {
      case 0:
        return func.getContent(value).부서명; // 부서명
      case 1:
        return func.getContent(value).담당주무관; // 주무관
      case 2:
        return func.getContent(value).부서주소; // 주소
      case 3:
        return func.getContent(value).부서연락처; // 연락처
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
